import { useSyncExternalStore } from 'react'
import {
  type PhotoPlacementSides,
  getPhotoPlacementSidesSnapshot,
  subscribePhotoPlacementSides,
} from '@/lib/photos/photo-placement-session'

/** candidId -> spreadId -> the pages of that spread this session knows the photo is on. */
export function usePhotoPlacementSides(): PhotoPlacementSides {
  return useSyncExternalStore(
    subscribePhotoPlacementSides,
    getPhotoPlacementSidesSnapshot,
    getPhotoPlacementSidesSnapshot
  )
}
